import { render, staticRenderFns } from "./EtapaPesagem.vue?vue&type=template&id=1d77b958"
import script from "./EtapaPesagem.vue?vue&type=script&lang=js"
export * from "./EtapaPesagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports